
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../utils";
import { setNotification } from "../notificationsSlice";
import { groupBy, has, toLower } from "lodash";
import { API_ACTIVATE_USER, API_DISABLE_USER, API_ISSUE_GRANT, API_USER_DETAILS, API_USER_SAVED_FILTER, API_USER_SAVED_FILTERS, API_USER_VERSION } from "../../settings";
import { schemas } from '../schemas';

export const getUserDetails = createAsyncThunk(
    "getUserDetails",
    async(email, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_USER_DETAILS, {
                headers: { "X-User-Email": toLower(email) }
            }, schemas.USER);
            if (has(response, "entities") && has(response.entities, "users")) {
                return response.entities.users[toLower(email)];
            }
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
        return rejectWithValue({});
    }
);

export const deleteUser = createAsyncThunk(
    "deleteUser",
    async(email, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_USER_DETAILS, {
                method: "delete",
                headers: { "X-User-Email": email }
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        };
    }
);

export const revokeGrant = createAsyncThunk(
    "revokeGrant",
    async({ email, alias }, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_ISSUE_GRANT, {
                method: "delete",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: email,
                    org_alias: alias
                })
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        };
    }
);

export const changeUserAccess = createAsyncThunk(
    "changeUserAccess",
    async({ email, disabled }, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(disabled ? API_ACTIVATE_USER : API_DISABLE_USER, {
                method: "PUT",
                headers: {
                    "X-User-Email": email
                }
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        }
    }
);

export const getUserSavedFilters = createAsyncThunk(
    "getUserSavedFilters",
    async(tab, { dispatch, rejectWithValue }) => {
        try {
            const url = tab ? API_USER_SAVED_FILTERS + "/" + tab : API_USER_SAVED_FILTERS;
            const response = await fetchData(url, {}, schemas.USER_SAVED_FILTERS);

            return groupBy(response.entities.filters, 'collection');
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        }
    }
);

export const saveFilter = createAsyncThunk(
    "saveQueryFilter",
    async({ tab, name, search }, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_USER_SAVED_FILTERS, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    collection: tab,
                    name: name,
                    content: search
                })
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        }
    }
);

export const deleteFilter = createAsyncThunk(
    "deleteQueryFilter",
    async(id, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_USER_SAVED_FILTER(id), {
                method: "DELETE"
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        }
    }
);

export const updateFilter = createAsyncThunk(
    "updateQueryFilter",
    async({ id, search }, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_USER_SAVED_FILTER(id), {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    content: search
                })
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        }
    }
);

export const updateUserVersion = createAsyncThunk(
    "updateUserVersion",
    async(version, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_USER_VERSION, {
                method: "PUT",
                headers: {
                    "X-App-Version": version
                }
            }, {});
            return response.result.version;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        }
    }
);